import { useQuery } from "@tanstack/react-query";
import useApi from "../utils/useApi";

export default function useGeneralRevenueGoalChart(
  start_date,
  end_date,
  revenue_mode = "presencial",
  branch_id = null,
  enabled = true,
  seller_erp_code = null
) {
  const { getGeneralRevenueGoalChart } = useApi();

  const { data, isLoading, isError, error } = useQuery({
    queryKey: [
      "general-revenue-goal-chart",
      start_date,
      end_date,
      revenue_mode,
      branch_id,
      seller_erp_code,
    ],
    queryFn: () =>
      getGeneralRevenueGoalChart({
        start_date,
        end_date,
        revenue_mode,
        ...(branch_id ? { branch_id } : {}),
        ...(seller_erp_code ? { seller_erp_code } : {}),
      }),
    enabled: Boolean(enabled && start_date && end_date),
  });

  return {
    data: data?.data,
    isLoading,
    isError,
    error,
  };
}
